import axios from "axios";
import { FilterDate, SourceFilterDate } from "../interfaces/Settings";

export const API_URL = process.env.REACT_APP_API_URL

const GET_SETTING_ALL = `${API_URL}settings`
const SAVE_SETTING = `${API_URL}setting`
const TEMPLATE_SETTING_PIPELINE = `${API_URL}lead-templates`
const LEAD_OPTIONS_MERCHANT_TEMPLATE = `${API_URL}lead-template-merchant-template-accesses`
const SET_ACCESS_PROGRESS_PIPELINE = `${API_URL}lead-template-lead-progress-accesses/`
const SET_ACCESS_PRODUCT_PIPELINE = `${API_URL}lead-template-product-accesses/`
const TEMPLATE_SETTING_MERCHANT = `${API_URL}merchant-templates`
const MERCHANT_OPTIONS = `${API_URL}merchant-template`
const TEMPLATE_SETTING_MEETING = `${API_URL}meeting-templates`
const TEMPLATE_SETTING_REIMBURSMENT = `${API_URL}reimbursement-templates`
const MEETING_OPTIONS = `${API_URL}meeting-template`
const GET_MERCHANT_LINK = `${API_URL}merchant-link`
const GET_LIST_MERCHANT_LINK = `${API_URL}merchant-link/custom-list`
const SAVE_MERCHANT_LINK = `${API_URL}merchant-link`

export const getSettingAll = (token: string) => {
    return axios.get(GET_SETTING_ALL,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const saveSetting = (key: string, value: string|number, token: string) => {
    return axios.put(SAVE_SETTING,
        {
            key,
            value
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

// ------------------------------------------------------------------- LEAD TEMPLATE -------------------------------------------------------------------

export const getTemplateSettingPipeline = (token: string, id?: string) => {
    return axios.get(TEMPLATE_SETTING_PIPELINE+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getPipelineOptionMerchantTemplate = (token: string, id?: string) => {
    return axios.get(LEAD_OPTIONS_MERCHANT_TEMPLATE+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const addTemplateSettingPipeline = (
    token: string, 
    name: string, 
    currencyId: number,
    merchantTemplateIds: string[],
    roleIds: string[],
    leadProgressIds: string[],
	productIds: string[],
    customFields: object, 
    isFeatureLabelEnabled: boolean,
    isFeatureCogsEnabled: boolean,
    leadSourcesId: string[],
    allowOptionalProducts: boolean,
    isInfiniteLog?: boolean,
    isAllowAfterFailedLog?: boolean,
    isAllowAfterSuccessLog?: boolean,
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.post(TEMPLATE_SETTING_PIPELINE,
        {
            name,
            currencyId,
            merchantTemplateIds,
            roleIds,
            leadProgressIds,
            productIds,
            customFields,
            isFeatureLabelEnabled,
            isFeatureCogsEnabled,
            leadSourcesId,
            allowOptionalProducts,
            isInfiniteLog,
            isAllowAfterFailedLog,
            isAllowAfterSuccessLog,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const updateTemplateSettingPipeline = (
    token: string, 
    id: string, 
    name: string, 
    currencyId: number,
    merchantTemplateIds: string[],
    roleIds: string[],
    leadProgressIds: string[],
	productIds: string[],
    customFields: object, 
    isFeatureLabelEnabled: boolean,
    isFeatureCogsEnabled: boolean,
    leadSourcesId: string[],
    allowOptionalProducts: boolean,
    isInfiniteLog: boolean,
    isAllowAfterFailedLog: boolean,
    isAllowAfterSuccessLog: boolean,
    sourceFilterDate: SourceFilterDate,
    filterDate: FilterDate,
    variantPriceId: string|null,
    isDisabledPriceProduct: boolean
) => {
    return axios.patch(TEMPLATE_SETTING_PIPELINE+"/"+id,
        {
            name,
            currencyId,
            merchantTemplateIds,
            roleIds,
            customFields,
            leadProgressIds,
            productIds,
            isFeatureLabelEnabled,
            isFeatureCogsEnabled,
            leadSourcesId,
            allowOptionalProducts,
            isInfiniteLog,
            isAllowAfterFailedLog,
            isAllowAfterSuccessLog,
            sourceFilterDate,
            filterDate,
            variantPriceId,
            isDisabledPriceProduct
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const reOrderTemplateSettingPipeline = (
    token: string, 
    leadTemplateIds: string[],
) => {
    return axios.patch(TEMPLATE_SETTING_PIPELINE+"/order",
        {
            leadTemplateIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const deleteTemplateSettingPipeline = (id: string, token: string) => {
    return axios.delete(TEMPLATE_SETTING_PIPELINE+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const setAccessProgressPipeline = (leadProgressIds: string[], idPipeline: string, token: string) => {
    return axios.patch(SET_ACCESS_PROGRESS_PIPELINE+idPipeline,
        {
            leadProgressIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const setAccessProductPipeline = (productIds: string[], idPipeline: string, token: string) => {
    return axios.patch(SET_ACCESS_PRODUCT_PIPELINE+idPipeline,
        {
            productIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

// ------------------------------------------------------------------- MERCHANT TEMPLATE -------------------------------------------------------------------

export const getTemplateSettingMerchant = (token: string, id?: string) => {
    return axios.get(TEMPLATE_SETTING_MERCHANT +"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getMerchantOptionPipelineTemplate = (token: string, id?: string) => {
    return axios.get(MERCHANT_OPTIONS + "-lead-template-accesses/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getMerchantOptionMeetingTemplate = (token: string, id?: string) => {
    return axios.get(MERCHANT_OPTIONS + "-meeting-template-accesses/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const addTemplateSettingMerchant = (
    token: string, 
    name: string, 
    leadTemplateIds: string[], 
    meetingTemplateIds: string[], 
    customFields: object = {}, 
    isFeatureLabelEnabled: boolean,
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.post(TEMPLATE_SETTING_MERCHANT,
        {
            name,
            leadTemplateIds,
            meetingTemplateIds,
            customFields,
            isFeatureLabelEnabled,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const deleteTemplateSettingMerchant = (id: string, token: string) => {
    return axios.delete(TEMPLATE_SETTING_MERCHANT+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const updateTemplateSettingMerchant = (
    id: string, 
    name: string, 
    customFields: object, 
    leadTemplateIds:object, 
    token: string, 
    meetingTemplateIds: string[],
    isFeatureLabelEnabled: boolean,
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.patch(TEMPLATE_SETTING_MERCHANT+"/"+id,
        {
            name,
            customFields, 
            leadTemplateIds,
            meetingTemplateIds,
            isFeatureLabelEnabled,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const reOrderTemplateSettingMerchant = (
    token: string, 
    merchantTemplateIds: string[],
) => {
    return axios.patch(TEMPLATE_SETTING_MERCHANT+"/order",
        {
            merchantTemplateIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

// ------------------------------------------------------------------- MEETING TEMPLATE -------------------------------------------------------------------

export const getTemplateSettingMeeting = ( token: string, id: string='') => {
    return axios.get(TEMPLATE_SETTING_MEETING + '/' + id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getMeetingOptionMerchantTemplate = (token: string, id?: string) => {
    return axios.get(MEETING_OPTIONS + "-merchant-template-accesses/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const addTemplateSettingMeeting = (
    token: string, 
    name: string,  
    merchantTemplateIds:string[], 
    customFields: {}={},
    isFeatureLabelEnabled: boolean,
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.post(TEMPLATE_SETTING_MEETING,
        {
            name,
            merchantTemplateIds,
            customFields,
            isFeatureLabelEnabled,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const deleteTemplateSettingMeeting = (id: string, token: string) => {
    return axios.delete(TEMPLATE_SETTING_MEETING+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const updateTemplateSettingMeeting = (
    id: string, 
    name: string, 
    customFields: {}, 
    merchantTemplateIds:{}, 
    token: string,
    isFeatureLabelEnabled: boolean,
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.patch(TEMPLATE_SETTING_MEETING+"/"+id,
        {
            name,
            customFields, 
            merchantTemplateIds,
            isFeatureLabelEnabled,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const reOrderTemplateSettingMeeting = (
    token: string, 
    meetingTemplateIds: string[],
) => {
    return axios.patch(TEMPLATE_SETTING_MEETING+"/order",
        {
            meetingTemplateIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getMerchantLinkSetting = (idTemplate: string, token: string) => {
    return axios.post(GET_MERCHANT_LINK,
        {
            idTemplate
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const getListMerchantLinkSetting = (idSourceTemplate: string, token: string) => {
    return axios.post(GET_LIST_MERCHANT_LINK,
        {
            idSourceTemplate
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const saveSettingMerchantLink = (merchantLinkId: string, merchantTemplateSourceId: string, merchantTemplateDestination: any, token: string) => {
    return axios.patch(SAVE_MERCHANT_LINK,
        {
            merchantLinkId,
            merchantTemplateDestination,
            merchantTemplateSourceId
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}



// ------------------------------------------------------------------- REIMBURSEMENT TEMPLATE -------------------------------------------------------------------

export const addTemplateSettingReimbursement = (
    token: string, 
    name: string, 
    customFields: object, 
    sourceFilterDate?: SourceFilterDate,
    filterDate?: FilterDate
) => {
    return axios.post(TEMPLATE_SETTING_REIMBURSMENT,
        {
            name,
            customFields,
            sourceFilterDate,
            filterDate,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const deleteTemplateSettingReimbursement = (id: string, token: string) => {
    return axios.delete(TEMPLATE_SETTING_REIMBURSMENT+"/"+id,
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const updateTemplateSettingReimbursement = (
    token: string, 
    id: string, 
    name: string,
    customFields: object, 
    sourceFilterDate: SourceFilterDate,
    filterDate: FilterDate
) => {
    return axios.patch(TEMPLATE_SETTING_REIMBURSMENT+"/"+id,
        {
            name,
            customFields,
            sourceFilterDate,
            filterDate
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}

export const reOrderTemplateSettingReimbursement = (
    token: string, 
    reimbursementTemplateIds: string[],
) => {
    return axios.patch(TEMPLATE_SETTING_REIMBURSMENT+"/order",
        {
            reimbursementTemplateIds
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}